export default __webpack_public_path__ + "static/media/preview-icon.beb91438.svg";